import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-policy',
  templateUrl: './update-policy.component.html',
  styleUrls: ['./update-policy.component.scss']
})
export class UpdatePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
